const styles = {
  privacyPreferences: {
    height: "32px",
    zIndex: "800",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
};

export default styles;
